import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
  locales: [
    "ar",
    "bg",
    "cs",
    "da",
    "de",
    "el",
    "en",
    "es",
    "fi",
    "fr",
    "hi",
    "hr",
    "hu",
    "it",
    "ja",
    "ko",
    "nl",
    "no",
    "pl",
    "pt",
    "ro",
    "ru",
    "sk",
    "sl",
    "sr",
    "sv",
    "tr",
    "uk",
    "zh",
  ],
  defaultLocale: "en",
  localeDetection: false,
  localePrefix: "never",
});

export { domainCountryMap, domainLocaleMap } from "@/lib/domainConfig";
